import { render, staticRenderFns } from "./RecordingView.vue?vue&type=template&id=5dc2ee78&"
import script from "./RecordingView.vue?vue&type=script&lang=js&"
export * from "./RecordingView.vue?vue&type=script&lang=js&"
import style0 from "./styles/event-hub.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports